export const environment = {
  IsProduction: false,
  IsHero: false,
  migrationDiffCompareEnabled: false,
  environment: 'dev',
  launchDarklyClientId: "664590c02c638010dc55095f",
  joditLicenseKey: 'K3IKB-0PI70-DR5LL-YOFOY',
  oneTimeTokenName: 'fenixOneTimeToken',
  analyticsAppId: 'configurator',
  analyticsSdkScriptUrl:
    'https://webanalytics-sdk.testtools.devtest.gf.aws.scania.com/analytics.sdk.js',
};

export const authentication = {
  authLayerStagingUrl: 'https://ehlfaue7jfexfalnchzbb672sq.appsync-api.eu-north-1.amazonaws.com/graphql',
	authLayerReleaseUrl: 'https://tfsusyfgjnaitctqbnqad3v2bq.appsync-api.eu-north-1.amazonaws.com/graphql'
}
export const Config = {
  colaConfig: {
    disabled: false,
    redirectUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com/login'
  }
}

export const links = {
  testToolsUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com',
  blogAndNewsUrl: 'https://testtools.testtools.devtest.gf.aws.scania.com/blogs-news?label=configurator',
}

export const AbstractionLayerConfig = {
  stagingUri: 'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql',
  releaseUri: 'https://5oetsllb2jfelbghdyob2uy2r4.appsync-api.eu-north-1.amazonaws.com/graphql'
}

export const FenixDomainDataConfig = {
  stagingUri: 'https://quobkvexmre7blsb7ltpdz2xxi.appsync-api.eu-north-1.amazonaws.com/graphql',
  releaseUri: 'https://5oetsllb2jfelbghdyob2uy2r4.appsync-api.eu-north-1.amazonaws.com/graphql'
}

export const polarion = {
  itemWithNewestRevisionUrl : `https://share-dev.polarion.devtest.gf.aws.scania.com/polarion/#/workitem?id={0}`,
  itemWithRevisionUrl : `https://share-dev.polarion.devtest.gf.aws.scania.com/polarion/#/workitem?id={0}&revision={1}`,
};
